import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressBar } from '@feathr/components';

import type { TProgressMode } from './ProgressCell.utils';

import * as styles from './ProgressCell.css';

interface IProgressCellProps {
  label: string;
  mode: TProgressMode;
}

function ProgressCell({ label, mode }: Readonly<IProgressCellProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  if (mode.kind === 'notApplicable') {
    return <span className={styles.label}>{t('N/A')}</span>;
  }

  if (mode.kind === 'calculating') {
    return <span className={styles.label}>{t('Calculating…')}</span>;
  }

  if (mode.kind === 'complete') {
    return (
      <Stack align={'flex-start'} gap={theme.spacing['1']} w={'100%'}>
        <ProgressBar aria-label={label} shade={600} theme={'green'} value={100} />
        <span className={styles.percentComplete}>{t('{{percent}}%', { percent: 100 })}</span>
      </Stack>
    );
  }

  return (
    <Stack align={'flex-start'} gap={theme.spacing['1']} w={'100%'}>
      <ProgressBar aria-label={label} shade={600} theme={'yellow'} value={mode.percent} />
      <span className={styles.percent}>{t('{{percent}}%', { percent: mode.percent })}</span>
    </Stack>
  );
}

export default ProgressCell;
